/**
 * Bank-párosítás guard-error → i18n toast-kulcs (35-kör Fázis-2, money-write).
 *
 * A BE 6 strukturált guard-code-ot ad az `ApiError.code`-ban (#712, a #653
 * warranty-basket-error-minta): a párosítás-UI ezekre code-alapú toast-kulcsot
 * képez — nyelv-/refaktor-független, NEM message-substring. Ismeretlen code /
 * nem-ApiError esetén generikus fallback (defense-in-depth).
 */
import { ApiError } from '@/api/client';

/** A 6 BE-guard-code (#712) → i18n toast-kulcs (bank.match.error.*). */
const BANK_MATCH_ERROR_KEYS: Record<string, string> = {
  BANK_MATCH_OVERPAY: 'bank.match.error.overpay',
  BANK_MATCH_OUT_NOT_ALLOWED: 'bank.match.error.outNotAllowed',
  BANK_MATCH_AMOUNT_MUST_BE_POSITIVE: 'bank.match.error.amountPositive',
  BANK_MATCH_ALREADY_EXISTS: 'bank.match.error.alreadyExists',
  INVOICE_NOT_FOUND: 'bank.match.error.invoiceNotFound',
  BANK_TRANSACTION_NOT_FOUND: 'bank.match.error.transactionNotFound',
};

/**
 * A párosítás-hibából (ApiError.code) a megfelelő i18n toast-kulcs.
 * Code-alapú (#653-minta, message-független); ismeretlen code / nem-ApiError →
 * generikus fallback.
 */
export function bankMatchErrorToastKey(err: unknown): string {
  if (err instanceof ApiError && err.code !== undefined) {
    const key = BANK_MATCH_ERROR_KEYS[err.code];
    if (key !== undefined) {
      return key;
    }
  }
  return 'bank.match.error.generic';
}
